import { UNSTABLE_ToastRegion as RACToastRegion } from 'react-aria-components';
import { internalToastQueue } from './toast-queue.js';
import { UNSTABLE_Toast } from './toast.js';

/**
 * Displays toast notifications. Toast notifications are non-intrusive messages that appear briefly at the top of the page, overlaying content.
 *
 * See [toast usage guidelines](https://ui.cimpress.io/components/toast/).
 */
export function UNSTABLE_ToastRegion() {
  return (
    <RACToastRegion queue={internalToastQueue} className="cim-toast-region" data-cim-style-root>
      {({ toast }) => <UNSTABLE_Toast toast={toast} />}
    </RACToastRegion>
  );
}
